import $ from 'jquery'

import colors from '../../../../lib/colors'

import { button, input } from '../../../../component/component'

export default function(o,field,name,done){

  var init = function(){
    requestAnimationFrame(function(){
      inputDiv.focus()
    })
  }

  var update = function(){

    resultDiv.empty()

    var value = inputDiv.val()

    if(!value){
      return
    }

    var filteredOptions =
      _.filter(field.options,function(option){
        return _.includes(option.toLowerCase(), value.toLowerCase())
      })

    _.each(filteredOptions,function(option,i){
      var optionDiv = 
        button(option,'fi-plus')
        .css({
          display: 'block',
          borderBottom: `1px solid ${colors.black}`,
          borderRight: `1px solid ${colors.black}`,
        })
        .click(function(){
          select(option)
        })
      if(i === 0){
        optionDiv.addClass('mousetrapShiftEnter')
      }
      resultDiv.append(optionDiv)
    })

  }

  var insert = function(){

    var model = field.optionsModel

    model.insertForm(o, function(item){
      var lang = o.store('lang')
      select(item[lang])
    })

  }

  var close = function(){
    div.remove()
  }

  var select = function(value){
    div.remove()
    done(value)
  }

  var label = name+'/'+field.id
  label = label.toUpperCase()
  var labelDiv = 
    button(label,null,true)
    .css({
      position: 'absolute',
      top: 0,
      left: 0,
    })

  var closeDiv = 
    button(null,'fi-x')
    .addClass('mousetrapEsc') 
    .css({
      position: 'absolute',
      top: 0,
      right: 0,
    })
    .click(close)

  var insertDiv = 
    button(null,'fi-plus')
    .css({
      position: 'absolute',
      top: 0,
      right: '34px',
    })
    .click(insert)

  var headerDiv =
    $('<div>')
    .css({
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0,
      height: '34px',
      color: colors.white,
      overflow: 'hidden',
      borderBottom: '1px solid '+colors.grey.s_800,
    })
    .append([
      labelDiv,
      closeDiv,
      insertDiv,
    ])

  var inputDiv =
    input()
    .css({
      position: 'absolute',
      top: '34px',
      right: 0,
      left: 0,
      height: '34px',
    })
    .on('keyup',update)

  var resultDiv = 
    $('<div>')
    .css({
      position: 'absolute',
      top: '68px',
      bottom: 0,
      right: 0,
      left: 0,
      borderTop: `1px solid ${colors.black}`,
      overflow: 'scroll',
    })
    .append(
      button('start typing',null,true,colors.grey.s_500)
    )

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,  
      background: colors.black,
    })
    .append([
      headerDiv,
      inputDiv,
      resultDiv,
    ])

  o.edit.append(div)

  init()

}



// WEBPACK FOOTER //
// ./src/client/view/admin/edit/option/option.js